// Package E — Pure data-shaping for the PDF export. Consumes the EXACT
// same categories/summaryRows the UI already computed via
// buildCategoryTree()/buildTakeoffSummaryRows() — this file performs
// ZERO calculation of its own. It only reshapes already-correct
// numbers into a model renderTakeoffReportPdf() can turn into HTML.
export function buildTakeoffReportPdfModel({ categories, summaryRows, tenderName, preparedBy, reportDate }) {
  return {
    header: {
      tenderName: tenderName || '-',
      preparedBy: preparedBy || '-',
      reportDate: reportDate || new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }),
      drawingCount: new Set(categories.flatMap((c) => c.items.flatMap((i) => i.sheets.map((s) => s.drawingName)))).size,
    },
    summaryRows: summaryRows.map((r) => ({ ...r })), // shallow copy — values untouched.
    categories: categories.map((cat) => ({
      id: cat.id,
      code: cat.code,
      name: cat.name,
      totalsByUnit: Array.from(cat.totalsByUnit.entries()), // Map -> array, still the same numbers.
      items: cat.items.map((item) => ({
        id: item.id,
        description: item.description,
        unit: item.unit,
        total: item.total,
        sheets: item.sheets.map((s) => ({ ...s })),
      })),
    })),
  }
}
